<template>
  <div class="main-holder">
    <div class="top-holder">
      <div class="search-holder">
        <form @submit.prevent="handleSearch">
          <input
            type="text"
            v-model="query"
            :placeholder="$t('search_bar.input_placeholder')"
          />
        </form>
        <div class="search-icon-holder" @click="handleSearch">
          <i class="fal fa-search"></i>
        </div>
        <div class="results-for-query"></div>
      </div>
      <div class="live-video-wrapper">
        <div style="position: absolute; top: 0; left: 0; width: 100%">
          <LiveStreamWindow />
        </div>
      </div>
    </div>
    <div
      :style="`background-image: url(${background})`"
      class="content-wrapper collar-recomen"
    >
      <div class="content-inner">
        <div class="collar">
          <span class="recomendation-name">{{
            $t("search_bar.recomend")
          }}</span>
        </div>

        <div class="content-holder" ref="content">
          <div
            class="card-wrapper"
            v-for="(item, index) in recommendations"
            :class="{ additional: index % 2 !== 0 }"
            :key="item.id"
          >
            <router-link
              :to="
                $i18nRoute({
                  name: 'NewsDetail',
                  params: { slug: item.url, category: 'feed' },
                })
              "
              class="card-inner"
            >
              <div class="img-container">
                <ImageContainer
                  :src="item.image.medium"
                  :thumb="item.image.thumbnail"
                  :alt="item.title"
                />
                <div class="cat-holder">{{ item.sub_category.name }}</div>
              </div>
              <div class="meta-holder">
                <div class="title limited-text" style="--snup: 4">
                  {{ item.title }}
                </div>
                <div class="date-wrapper">
                  <span class="date">{{ handleDate(item.pub_date) }},</span>
                  <span class="date" style="padding-left: 0.44em">{{
                    handleTime(item.pub_date)
                  }}</span>
                </div>
              </div>
            </router-link>
          </div>
        </div>
        <div class="content-holder" v-if="show.spinner">
          <div
            class="card-wrapper pointer-none"
            v-for="(item, index) in 10"
            :class="index % 2 === 0 ? '' : 'additional'"
            :key="item"
          >
            <div class="card-inner">
              <div class="img-container">
                <div class="kground" />
                <div class="cat-holder"></div>
              </div>
              <div class="meta-holder">
                <div class="title limited-text" style="--snup: 4">
                  <span class="kground">
                    Instead Instead Instead much peace according appearmajor
                    push. Instead much peace according meet appearmajor push.
                    Instead much peace
                  </span>
                </div>
                <div class="date-wrapper">
                  <span class="date kground">31.05.2021.12.12 , 00:00</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, reactive, watch } from "vue";
import { useRouter } from "vue-router";
import LiveStreamWindow from "@/components/LiveStreamWindow";
import ImageContainer from "@/components/ImageContainer";
import { useLanguage } from "@/utils/language";
import { useInfiniteScroll } from "@/utils/infiniteScroll";
import { useStore } from "vuex";
import { useFormatter } from "@/utils/formatter";

export default {
  components: {
    LiveStreamWindow,
    ImageContainer,
  },
  setup() {
    const router = useRouter();
    const store = useStore();
    const query = ref("");
    const content = ref(null);
    const show = reactive({
      spinner: true,
    });

    const { i18n } = useLanguage();

    const pageSize = 10;

    const handleSearch = () => {
      if (query.value !== undefined && query.value?.trim().length > 0) {
        router.push({
          name: `${i18n.global.locale.value || i18n.global.locale}_SearchQuery`,
          params: {
            query: query.value.trim(),
            category: "feed",
          },
        });
      }
    };

    const scrollEnd = () => {
      show.spinner = false;
    };

    const refreshData = () => {
      store.commit("flushSearchRecommendState");
      const { startInfiniteScroll, loadData } =
        useInfiniteScroll({
          wrapper: content,
          retrieve: async (load) => {
            await store.dispatch("getLatestRecommendations", {
              pageSize,
              load,
            });
          },
          newsCount: computed(() => store.getters.searchReccomendCount),
          currentPage: computed(() => store.getters.searchReccomendPage),
          pageSize,
          scrollEnd,
        });
      startInfiniteScroll();
      show.spinner = true;
      loadData();
    };

    watch(
      () => i18n.global.locale.value,
      () => refreshData(),
      { immediate: true }
    );

    return {
      show,
      query,
      content,
      background: require("@/assets/words-bg.png"),
      handleSearch,
      recommendations: computed(() => store.getters.searchReccomend),
      ...useFormatter(),
    };
  },
};
</script>

<style lang="scss" scoped>
.main-holder {
  --top-offset: calc(160px + 30px);
  margin-top: var(--top-offset);
  width: 100%;

  .top-holder {
    display: flex;
    justify-content: flex-end;
    width: var(--main-wrapper-width);
    margin-left: auto;
    margin-right: auto;

    .search-holder {
      width: 100%;
      max-width: 837px;
      position: relative;

      input {
        width: 100%;
        height: 56px;
        font-family: Open Sans;
        font-size: 1.25em;
        background-color: transparent;
        border-radius: 4px;
        transition: all 0.4s ease;
        color: var(--primary-font-color);
        border: 1px solid rgba(var(--secondary-bg), 0.5);
        padding-left: 30px;
      }

      .search-icon-holder {
        position: absolute;
        right: -30px;
        top: 1px;
        height: 56px;
        width: 56px;
        font-size: 2.4em;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        background-color: var(--background-color);
      }

      .results-for-query {
        font-family: Open Sans;
        font-size: 1.5em;
        line-height: 1.875em;
        padding-top: 1.875rem;
        padding-bottom: 2.5rem;
      }
    }

    .live-video-wrapper {
      width: 368px;
      margin-left: 5.875rem;
      position: relative;
    }
  }

  .collar-recomen {
    // Рекомендации для вас
    margin-top: 3em;
    .content-inner {
      padding-top: 4rem !important;
    }
  }

  .content-wrapper {
    width: 100%;
    height: auto;

    .content-inner {
      width: var(--main-wrapper-width);
      margin-left: auto;
      margin-right: auto;
      height: auto;
      position: relative;
      // padding-top: 2.5rem;
      padding-top: 3rem;
      padding-bottom: 7.75rem;
      margin-bottom: 5.625rem;

      .collar {
        position: absolute;
        top: 0;
        left: 70px;
        width: 50%;
        height: 100%;
        background-color: var(--foreground-color);
        border-radius: 7px;

        .recomendation-name {
          display: inline-block;
          position: relative;
          padding: 0.3em 1em;
          font-size: 1.5em;
          color: black;
        }
        .collar-meta {
          font-family: Open Sans;
          margin-top: 5px;
          margin-left: 34px;
          font-weight: 300;
          font-size: 1.2em;
          line-height: 1.5em;
          color: rgba(var(--primary-bg), 0.6);
          cursor: pointer;

          i {
            margin-right: 8px;
          }
        }
      }

      // .content-holder {
      //   margin-top:20px;
      // }

      .card-wrapper {
        --border-color: var(--foreground-color);
        color: var(--secondary-font-color);
        height: 144px;
        position: relative;
        width: 100%;
        max-width: 720px;

        .card-inner {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          cursor: pointer;
          display: flex;

          .img-container {
            position: relative;
            width: 300px;
            height: 200px;
            border: 10px solid var(--border-color);
            border-radius: 4px;
            background-color: var(--border-color);

            .cat-holder {
              position: absolute;
              top: 0;
              left: 0;
              background-color: var(--border-color);
              font-family: Open Sans;
              font-weight: bold;
              line-height: 1.5em;
              padding-left: 0.375rem;
              padding-right: 0.625rem;
              text-transform: uppercase;
            }

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 4px;
            }
          }

          .meta-holder {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            margin-top: 2.5rem;
            max-width: 320px;

            .title {
              font-family: Alice;
              font-weight: 500;
              font-size: 1.25em;
            }

            .date {
              font-family: Open Sans;
              font-weight: 300;
              line-height: 1.25rem;
              margin-bottom: 10px;
            }
          }
        }

        &.additional {
          --border-color: var(--background-color);
          color: var(--primary-font-color);
          margin-left: clamp(50%, 720px, 100%);
        }
      }
    }
  }
}

.filter_arrow {
  display: flex;
  align-items: center;
  i {
    display: inline-block;
    font-size: 1.8em;
    color: black;
  }
}

@media screen and (max-width: 1536px) {
  .collar {
    width: 55% !important;
    left: 70px !important;
  }
  .card-wrapper {
    height: 114px !important;
    max-width: 560px !important;
    .img-container {
      width: 240px !important;
      height: 160px !important;
    }
    .meta-holder {
      max-width: 290px !important;
      font-size: 1.1em !important;
      margin-top: 1.2em !important;
    }
  }
  .collar-meta {
    margin-top: 10px !important;
    // color: white  !important;
    margin-left: 50px !important;
    font-size: 1.5em !important;
    font-weight: 900 !important;
    white-space: nowrap;
  }
  .filter_arrow {
    margin-right: 5px;
    i {
      // color: white !important;
      font-size: 1.9em !important;
    }
  }
}

@media screen and (max-width: 1366px) {
  .main-holder {
    zoom: 0.8;
  }
}

@media screen and (max-width: 1100px) {
  .collar {
    left: 120px !important;
  }
  .additional {
    margin-left: 55% !important;
  }
  .card-wrapper {
    height: 104px !important;
    max-width: 500px !important;
    .img-container {
      width: 210px !important;
      height: 130px !important;
    }
    .meta-holder {
      max-width: 260px !important;
    }
  }
}
@media screen and (max-width: 900px) {
  .collar {
    width: 50% !important;
    left: 60px !important;
  }
  .additional {
    margin-left: 52% !important;
  }
  .card-wrapper {
    height: 94px !important;
    max-width: 450px !important;
    .img-container {
      width: 200px !important;
    }
    .meta-holder {
      max-width: 210px !important;
    }
  }
}

@media screen and (max-width: 765px) {
  .content-inner {
    margin-bottom: 1.625rem !important;
    padding-bottom: 1.75rem !important;
    .collar {
      left: 15% !important;
      min-width: 290px !important;
    }
  }
  .live-video-wrapper {
    display: none;
  }
  .main-holder {
    margin-top: 6em !important;
    .top-holder {
      justify-content: center;
      .search-holder {
        position: relative;
        form {
          border: none;
          max-width: 70%;
          margin-left: auto;
          margin-right: auto;
          input {
            border: none;
            border-bottom: 3px solid rgba(255, 255, 255, 0.7);
            padding-left: 0px;
            height: 45px;
          }
        }
        .search-icon-holder {
          right: 15%;
          position: absolute;
          top: 0;
          background: inherit;
          font-size: 1.75em;
          height: 45px;
        }
        .results-for-query {
          font-size: 1.25em;
          padding-top: 1.275rem;
          padding-bottom: 1.4rem;
        }
      }
    }
  }
  .additional {
    margin-left: auto !important;
  }
  .card-wrapper {
    height: 175px !important;
    max-width: 400px !important;
    .img-container {
      width: 200px !important;
      border: 6px solid var(--border-color) !important;
      height: 140px !important;
    }
    .meta-holder {
      max-width: 190px !important;
    }
  }
}
@media screen and (max-width: 560px) {
  .collar {
    background-color: inherit !important;
    position: static !important;
    width: 100% !important;
    display: flex;
    justify-content: center;
  }
  .card-wrapper {
    color: var(--primary-font-color) !important;
    .img-container {
      border: 5px solid black !important;
      background-color: black !important;
      .cat-holder {
        background-color: black !important;
        color: white;
      }
    }
    .meta-holder {
      padding-left: 10px !important;
    }
  }
  .collar-meta {
    margin-top: 0px !important;
    color: white !important;
    margin-left: 0px !important;
    font-size: 1.4em !important;
    font-weight: 900 !important;
    white-space: nowrap;
  }
  .filter_arrow {
    margin-right: 5px;
    i {
      color: white !important;
      font-size: 1.9em !important;
    }
  }
  .results-for-query {
    padding-bottom: 0px !important;
  }

  .collar-recomen {
    margin-top: 0em !important;
  }
  .recomendation-name {
    color: white !important;
    padding: 0em 0em 1em 0em !important;
  }
}
@media screen and (max-width: 455px) {
  .search-holder {
    form {
      max-width: 90%;
      input {
        font-size: 1.25em;
        border-bottom: 2px solid rgba(255, 255, 255, 0.7);
        height: 40px;
      }
    }
    .search-icon-holder {
      height: 40px;
      right: 5%;
      font-size: 1.5em;
    }
    .results-for-query {
      font-size: 1.05em;
    }
  }
}
@media screen and (max-width: 400px) {
  .content-inner {
    margin-bottom: 1.625rem !important;
    padding-bottom: 1.75rem !important;
    .collar {
      left: 15% !important;
      min-width: 290px !important;
    }
  }
  .live-video-wrapper {
    display: none;
  }
  .main-holder {
    margin-top: 6em !important;
    .top-holder {
      justify-content: center;
      .search-holder {
        position: relative;
        form {
          border: none;
          max-width: 70%;
          margin-left: auto;
          margin-right: auto;
          input {
            border: none;
            border-bottom: 3px solid rgba(255, 255, 255, 0.7);
            padding-left: 0px;
            height: 45px;
          }
        }
        .search-icon-holder {
          right: 15%;
          position: absolute;
          top: 0;
          background: inherit;
          font-size: 1.75em;
          height: 45px;
        }
        .results-for-query {
          font-size: 1.25em;
          padding-top: 1.275rem;
          padding-bottom: 1.4rem;
        }
      }
    }
  }
  .additional {
    margin-left: 0 !important;
  }
  .card-wrapper {
    height: 165px !important;
    max-width: auto !important;
    .img-container {
      width: 190px !important;
      border: 0px solid var(--border-color) !important;
      height: 120px !important;
    }
    .meta-holder {
      max-width: 160px !important;
      margin-top: 0px !important;
      .date {
        margin-bottom: 0px !important;
      }
    }
  }
}
</style>
